import { ColorSwatch } from 'components/Design/ColorSwatch/ColorSwatch'
import Styles from './FillColor.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { GradientColor } from '../VisualEditor/Types'
import { Plus } from 'components/Design/ColorsPanel/Plus'
import { useState } from 'react'
import { GradientStopPicker } from './GradientStopPicker'
import { directionsToAngles } from 'components/Design/ColorsPanel/GradientDirectionEditor'
import { DEFAULT_SOLID_COLOR } from 'components/Design/ColorsPanel/constants'

type Props = {
  value: GradientColor
  onChange: (newValue: GradientColor) => any
}

export const GradientFill = ({ value, onChange }: Props) => {
  const [editingStopIndex, setEditingStopIndex] = useState<number | null>(null)

  if (!value) return null

  const handleChange = (partial: Partial<GradientColor>) => {
    const newValue = { ...value, ...partial }
    newValue.stops = newValue.stops.map((s, i) => ({ ...s, position: i / (newValue.stops.length - 1) }))
    onChange(newValue)
  }

  if (editingStopIndex != null) {
    return (
      <GradientStopPicker
        gradientValue={value}
        editingStopIndex={editingStopIndex}
        onChange={handleChange}
        onDone={() => setEditingStopIndex(null)}
      />
    )
  }

  return (
    <div className={Styles.gradientContainer}>
      <div>
        <Heading level={5}>Gradient Colors</Heading>
        <div className={Styles.colorsGrid}>
          <>
            {value.stops.map((stop, i) => (
              <div key={i} className={Styles.color}>
                <ColorSwatch color={{ type: 'solidColor', ...stop }} size={32} onPress={() => setEditingStopIndex(i)} />
              </div>
            ))}
            <span className={Styles.newGradientSwatchWrapper}>
              <ColorSwatch
                color={DEFAULT_SOLID_COLOR}
                size={32}
                onPress={() =>
                  handleChange({
                    stops: [
                      ...value.stops,
                      {
                        color: '#000000',
                        position: 1,
                        opacity: 1,
                      },
                    ],
                  })
                }
              >
                <span className={Styles.newGradientSwatchIcon}>
                  <Plus color="var(--dark-80)" />
                </span>
              </ColorSwatch>
            </span>
          </>
        </div>
      </div>
      <div>
        <Heading level={5}>Gradient Types</Heading>
        <div className={Styles.angleButtons}>
          {Object.values(directionsToAngles).map((angle) => (
            <div className={Styles.color} key={angle}>
              <ColorSwatch
                color={{ type: 'linearGradient', angle, stops: value.stops }}
                size={32}
                isSelected={value.angle === angle}
                onPress={() => handleChange({ angle })}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
